module.exports = __webpack_public_path__ + "fonts/VetoSansCond-CondLight_1.c88aaba7.woff";